const WHITE_LIST = [
  'https://startplus-web-dev1.dev.aws.castandcrew.com/',
  'https://startplus-web-qa1.dev.aws.castandcrew.com/',
  'https://startplus-stg2.us-west-2.dev.aws.castandcrew.com/',
  'https://demo.startplus.castandcrew.com/',
  'https://ext-uat.startplus.castandcrew.com/',
  'https://startplus.castandcrew.com/',
];

const whiteList = url => {
  if (!url) return null;
  for (let test of WHITE_LIST) {
    if (url.startsWith(test)) {
      return url;
    }
  }
  return null;
};

const parseQuery = search => {
  const params = {};
  if (search) {
    const options = search.replace('?', '').split('&');
    options.forEach(option => {
      const [key, value] = option.split('=');
      params[key.trim()] = decodeURI(value.trim());
    });
  }
  return params;
};

export default search => {
  const params = parseQuery(search);
  return whiteList(params.appReturn);
};
